import * as Routes from '@/router/routes';

export const CAMP_OPTIONS = (vm) => [
    {
        img: require('../../../../assets/img/edit.svg'),
        name: 'Edit',
        action: vm.openCampFormForEdit,
        permission: {
            name: 'camps.camps',
            rules: 'edit'
        }
    },
    {
        img: require('../../../../assets/img/copy.svg'),
        name: 'Duplicate',
        action: async () => {
            await vm.prefillCampForm(vm.campId);
            vm.$router.push({name: Routes.CAMP_FORM});
        },
        permission: {
            name: 'camps.camps',
            rules: 'add'
        }
    },
    {
        img: require('../../../../assets/img/link.svg'),
        name: 'Copy link',
        action: vm.copyLink,
        permission: {
            name: 'camps.camps',
            rules: 'copy'
        }
    },
    {
        img: require('../../../../assets/img/delete.svg'),
        name: 'Delete',
        action: vm.confirmDeleteCamp,
        permission: {
            name: 'camps.camps',
            rules: 'remove'
        }
    }
];


// WEBPACK FOOTER //
// ./src/components/main/pages/camps/camp.options.config.js